module.exports = __webpack_public_path__ + "static/flags/KI-41139fb32915030216cc06b1172d5d70.gif";